import { languagesList } from "../../utils/languages/languagesList";

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Backend caps a single send at 50 addresses. */
export const MAX_RECIPIENTS = 50;

/** Base language of the localization files — `languagesList` holds the translations. */
export const BASE_LANGUAGE = "en";

export const DEFAULT_PREVIEW_LANGUAGE = BASE_LANGUAGE;

/**
 * Sentinel for the send form's language select: leave delivery to each
 * recipient's own interface language (no `interfaceLanguage` in the payload).
 */
export const RECIPIENT_OWN_LANGUAGE = "__recipient_own_language__";

/**
 * The interface languages the Translations screens manage — the only slugs a
 * notification file is actually maintained in. Using the full LanguageCodes
 * enum here would report every unmaintained language as "missing".
 */
export const LANGUAGE_OPTIONS = Array.from(
  new Set([BASE_LANGUAGE, ...languagesList])
).map((code) => ({ value: code, label: code }));

/** Same list, prefixed with the per-recipient default, for the send form. */
export const SEND_LANGUAGE_OPTIONS = [
  {
    value: RECIPIENT_OWN_LANGUAGE,
    label: "Recipient's own language (default)",
  },
  ...LANGUAGE_OPTIONS,
];

export const RECIPIENT_PICKER_PAGE_SIZE = 10;

/** Expected 4xx when none of the recipients are reachable — a warning, not a crash. */
export const NO_FCM_MATCH_MESSAGE =
  "No matching users with FCM tokens found for provided emails";
